// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3mYZI","actions":"GroupTable_actions__2sgPt","deleteModalFooter":"GroupTable_deleteModalFooter__Xm4Qq"};